import { render, staticRenderFns } from "./LinkBranchServiceModal.vue?vue&type=template&id=06e1ced4&"
import script from "./LinkBranchServiceModal.vue?vue&type=script&lang=js&"
export * from "./LinkBranchServiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06e1ced4')) {
      api.createRecord('06e1ced4', component.options)
    } else {
      api.reload('06e1ced4', component.options)
    }
    module.hot.accept("./LinkBranchServiceModal.vue?vue&type=template&id=06e1ced4&", function () {
      api.rerender('06e1ced4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/branches/LinkBranchServiceModal.vue"
export default component.exports